export const tokenKey = "admin-token";

export const RequestStatuses = [
  { id: "new", name: "Новая" },
  { id: "in_process", name: "В обработке" },
  { id: "in_transit", name: "В пути" },
  { id: "completed", name: "Завершена" },
  { id: "canceled", name: "Отменена" },
];

export const FuelTransferStatuses = [
  { id: "pending", name: "Ожидает выполнения" },
  { id: "completed", name: "Выполнено" },
  { id: "canceled", name: "Отменено" },
];

// Причина перемещения:
export const FuelTransferReasons = [
  { id: "delivery", name: "Доставка топлива до азс" },
  { id: "sale", name: "Продажа контрагенту" },
  { id: "transfer", name: "Перемещение между азс" },
];

// Статус транспорта:
export const TransportTagStatuses = [
  { id: "free", text: "Свободен", color: "green", icon: "circle-check" },
  { id: "maintenance", text: "ТО", color: "orange", icon: "wrench" },
  { id: "repair", text: "На ремонте", color: "red", icon: "cog" },
  { id: "in_transit", text: "В пути", color: "purple", icon: "map" },
  {
    id: "not_specified",
    text: "Не указан",
    color: "gray",
    icon: "help-circle",
  },
];

// Состояние транспорта:
export const TransportConditionStatuses = [
  { id: "serviceable", text: "Исправно", color: "green", icon: "circle-check" },
  {
    id: "not_serviceable",
    text: "Требует ТО",
    color: "orange",
    icon: "circle-alert",
  },
];

// Статус заявки:
export const RequestTagStatuses = [
  {
    columnStatus: "new",
    statusTitle: "Новая заявка",
    statusClass: "tag--blue-light",
    statusIcon: "lightbulb",
  },
  {
    columnStatus: "in_process",
    statusTitle: "В обработке",
    statusClass: "tag--gray",
    statusIcon: "loader-circle",
  },
  {
    columnStatus: "in_transit",
    statusTitle: "В пути",
    statusClass: "tag--purple-light",
    statusIcon: "car",
  },
  {
    columnStatus: "completed",
    statusTitle: "Завершена",
    statusClass: "tag--green-light",
    statusIcon: "copy-check",
  },
  {
    columnStatus: "canceled",
    statusTitle: "Отменена",
    statusClass: "tag--red-light",
    statusIcon: "copy-x",
  },
];

export const TypeCounterpartyEnum = [
  { id: "juridical", title: "Юридическое лицо" },
  { id: "individual", title: "Индивидуальный предприниматель" },
  { id: "physical", title: "Физическое лицо" },
];

export const PayMethodCounterpartyEnum = [
  { id: "cashless", title: "Безнал" },
  { id: "cash", title: "Наличные" },
];

export const StatusCounterpartyEnum = [
  { id: "active", title: "Активен" },
  { id: "frozen", title: "Заморожен" },
];
